export default __webpack_public_path__ + "static/media/office-icon.9193acac.svg";